"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxLength = void 0;
const core_1 = require("@veeam/core");
const maxLength = (length, errorText) => {
    const requiredRule = (0, core_1.maxLength)(length !== null && length !== void 0 ? length : 255, errorText);
    return (value, values, ruleTexts) => {
        return length !== null ? requiredRule(value, values, ruleTexts) : '';
    };
};
exports.maxLength = maxLength;
//# sourceMappingURL=maxLength.js.map